import { render, staticRenderFns } from "./AssigneeUserCombo.vue?vue&type=template&id=41b8cfb4&"
import script from "./AssigneeUserCombo.vue?vue&type=script&lang=ts&"
export * from "./AssigneeUserCombo.vue?vue&type=script&lang=ts&"
import style0 from "./AssigneeUserCombo.vue?vue&type=style&index=0&id=41b8cfb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports